var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from "react";
import "../scss/DropdownMenu.scss";
import Backdrop from "../../backdrop/index.js";
import Button from "../../button";
var DropdownMenu = function (_a) {
    var children = _a.children, label = _a.label, _b = _a.cssClasses, cssClasses = _b === void 0 ? "" : _b;
    var _c = useState(false), isActive = _c[0], setIsActive = _c[1];
    var dropdownElement = document.getElementById('dropdown-menu-body');
    var dropdownButtonElement = document.getElementById('dropdown-menu-button');
    var preventFocusout = useCallback(function (ev) {
        if (!(dropdownElement === null || dropdownElement === void 0 ? void 0 : dropdownElement.contains(ev.relatedTarget))) {
            dropdownButtonElement === null || dropdownButtonElement === void 0 ? void 0 : dropdownButtonElement.focus();
        }
    }, [dropdownElement, dropdownButtonElement]);
    useEffect(function () {
        if (isActive) {
            [dropdownElement, dropdownButtonElement].forEach(function (el) { return el === null || el === void 0 ? void 0 : el.addEventListener("focusout", preventFocusout); });
        }
        else {
            [dropdownElement, dropdownButtonElement].forEach(function (el) { return el === null || el === void 0 ? void 0 : el.removeEventListener("focusout", preventFocusout); });
            dropdownButtonElement === null || dropdownButtonElement === void 0 ? void 0 : dropdownButtonElement.focus();
        }
    }, [isActive, dropdownElement, dropdownButtonElement, preventFocusout]);
    return (_jsxs("div", __assign({ className: "DropdownMenu ".concat(cssClasses + (isActive ? " DropdownMenu--isActive" : "")) }, { children: [_jsxs(Button, __assign({ type: "link", callback: function () { return setIsActive(!isActive); }, id: "dropdown-menu-button", "aria-haspopup": "true", "aria-expanded": isActive, "aria-controls": "dropdown-menu-body" }, { children: [label, _jsx("svg", __assign({ className: "DropdownMenu__arrow", xmlns: "http://www.w3.org/2000/svg", width: "18", height: "10" }, { children: _jsx("path", { d: "M.454.503A.5.5 0 0 1 .776.042a.5.5 0 0 1 .547.131l7.63 8.58 7.63-8.58a.5.5 0 0 1 .894.146.5.5 0 0 1-.154.514l-8 9a.49.49 0 0 1-.74 0l-8-9a.46.46 0 0 1-.13-.33h0z", fill: "#000", fillRule: "nonzero" }) }))] })), _jsx("ul", __assign({ id: "dropdown-menu-body", onKeyDown: function (e) { if (e.key === "Escape") {
                    setIsActive(false);
                } }, className: "DropdownMenu__body", "aria-labelledby": "dropdown-menu-button", hidden: !isActive }, { children: children.map(function (e, i) { return (_jsx("li", { children: e }, i)); }) })), isActive && (_jsx(Backdrop, { isTransparent: true, callback: function () { return setIsActive(!isActive); } }))] })));
};
export default DropdownMenu;
